<template>
  <div style="background-color: white">
  <div>
    <van-nav-bar title="数据填报" style="position:fixed;width: 100%;"  @click-left="onClickLeft" left-text="返回" left-arrow>
    </van-nav-bar>
    <div  style="padding-top: 45px">
    <van-row>
      <van-cell  title="选择填报日期" :value="tjdate" @click="show = true" />
      <van-calendar v-model="show" :min-date="new Date(new Date().setDate(new Date().getDate() - 3))" :max-date="new Date()" @confirm="onDateConfirm" />
      </van-row>
      <van-row  v-if="rbdatalist.length>0" v-for="(item,index) in rbdatalist" :key="index+'row'">
        <van-divider   :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }">
          {{zzlabel(item)}}
        </van-divider>
          <van-radio-group v-if="checkSzlxIsSelect(item.szlx)" v-model="item.val" direction="horizontal" style="margin: 0.5rem;">
            <van-radio v-for="(subitem,indexs) in fenjieItem(item.szlx)" :key="indexs+'rido'"  :name="subitem">{{subitem}}</van-radio>

          </van-radio-group>
          <van-cell-group v-else>
            <van-field v-model="item.val" :type="item.szlx=='number'?'number':'text'" placeholder="请输入" />
          </van-cell-group>
      </van-row>
      <div style="margin: 45px;color: gainsboro;text-align: center;">没有更多了！</div>
    </div>
  </div>
    <van-tabbar v-model="btactive" active-color="#7d7e80">
      <van-tabbar-item icon="share"  @click="tijiao">提交</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: 'sjtb',
  data () {
    return {
      btactive: 0,
      id: null,
      bzdata: null,
      // 表单参数
      form: {},
      show: false,
      rbdatalist: [],
      tjdate: null
    }
  },
  created () {
    // const id  = this.$route.params && this.$route.params.bzId;
    this.getbzdata()
    this.tjdate = this.$utils.formatDate(new Date())
  },
  activated () {
    this.getbzdata()
    this.tjdate = this.$utils.formatDate(new Date())
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },

    onDateConfirm (date) {
      this.show = false
      console.log(date)
      this.tjdate = this.$utils.formatDate(date)
    },
    checkSzlxIsSelect (item) {
      let selects = item.split('|')
      if (selects.length > 1) return true
      else return false
    },
    fenjieItem (item) {
      return item.split('|')
    },
    zzlabel (item) {
      console.log('zzlabel', item)
      if (item.dw) {
        return item.tbxmz + '(单位:' + item.dw + ')'
      }
      return item.tbxmz
    },
    zzdata (list) {
      let newlist = []
      list.map(item => {
        var node = {}
        node.val = item.val,
        node.tbxid = item.id
        node.tbbzid = item.bzid
        node.tbxmz = item.tbxmz
        node.deptid = item.deptid
        node.dw = item.dw
        node.szlx = item.szlx
        newlist.push(node)
      })
      return newlist
    },
    getbzdata () {
      let that = this
      this.$ajax.get('/xm/rbtbzb/tblist').then(function (res) {
        if (res.code == 200) {
          that.bzdata = res.data
          that.rbdatalist = that.zzdata(res.data.rbTbxxqList)
        } else {
          that.bzdata = []
          that.rbdatalist = []
        }
      })
    },
    tijiao () {
      this.rbdatalist.map(item => {
        item.rqdate = this.tjdate
      })
      this.bzdata.rbdatalist = this.rbdatalist
      console.log(this.rbdatalist)

      let that = this
      this.$ajax.post('/xm/rbtbzb/rbtx', this.bzdata).then(function (res) {
        if (res.code == 200) {
          that.$toast.success('填报完成')
          that.$router.push({path: '/work'})
        // that.$router.go(-1)
          // that.bzdata=res.data
          //  that.rbdatalist=that.zzdata(res.data.rbTbxxqList);
        }
      })
    }
  }
}

</script>

<style  lang="scss" scoped>
  // 底部标签栏
  .van-tabbar{
  .van-tabbar-item{
  &.van-tabbar-item--active{
     color: #1989fa !important;
   }
  &:first-child,&:last-child{
    color: #1989fa;
    background-color: #ECEDFD;//rgba(1, 1, 1, .6)//#DFE0E6;
  .van-tabbar-item__icon{
    font-size: 1rem;
  }
  }
  &:nth-child(2){
     color: #fff;
     background-color: #1989fa;
  &.van-tabbar-item--active{
     color: #fff !important;
   }
  }
  }
  }
</style>



// WEBPACK FOOTER //
// src/views/SjTb/edit.vue